export function isNodeVisible(node: Node): boolean {
  if (!(node instanceof HTMLElement)) {
    return false;
  }

  return node.offsetWidth > 0 && node.offsetHeight > 0;
}

type EmptyFn = () => void;
type WatchVisibleInit = {
  onVisible: EmptyFn,
  onHidden?: EmptyFn,
  observerInit?: Partial<IntersectionObserverInit>
}

/**
 * Planned removal [2026.9]
 * 
 * @deprecated signature is deprecated and will be replaced in the future.
 */
export function watchVisible(node: Node, onVisible: EmptyFn, onHidden?: EmptyFn): void
export function watchVisible(node: Node, { onVisible, onHidden }: WatchVisibleInit): void
/**
 * Watch node if it is visible on the screen, run callback methods on change and state.
 */
export function watchVisible(node: Node, onVisibleOrConfig: EmptyFn | WatchVisibleInit, onHidden?: EmptyFn): void {
  if (!(node instanceof Element)) {
    return;
  }

  const init: IntersectionObserverInit = {
    rootMargin: '-120px 0px',
  };

  if (typeof onVisibleOrConfig === 'object' && onVisibleOrConfig.observerInit) {
    init.root = onVisibleOrConfig.observerInit.root;
    init.rootMargin = onVisibleOrConfig.observerInit.rootMargin ?? '120px 0px';
    init.threshold = onVisibleOrConfig.observerInit.threshold;
  }

  const observer = new IntersectionObserver(
    (entries): void => {
      if (entries.some(e => e.isIntersecting)) {
        if (typeof onVisibleOrConfig === 'function') {
          onVisibleOrConfig();
        } else {
          onVisibleOrConfig.onVisible();
        }
      } else {
        if (typeof onVisibleOrConfig === 'function') {
          onHidden?.();
        } else {
          onVisibleOrConfig?.onHidden?.();
        }
      }
    },
    init
  );

  observer.observe(node);
}